angular.module('videosharing-embed').filter('videoSettings', function () {
	'use strict';
    return function (settings) {
        var params = [];
        angular.forEach(settings, function (value, key) {
            params.push([key, value].join('='));
        });
        return params.length > 0 ? "?" + params.join('&') : "";
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/ng-videosharing-embed/src/filters/videosettings.js
// module id = 1587
// module chunks = 1